import { useCallback, useEffect, useRef } from 'react';
import { Animated, Platform } from 'react-native';

type DotInterpolationsArray = readonly Animated.AnimatedInterpolation[];

export const useDotAnimations = (): DotInterpolationsArray => {
  const animationValue1 = useRef(new Animated.Value(0)).current;
  const animationValue2 = useRef(new Animated.Value(0)).current;
  const animationValue3 = useRef(new Animated.Value(0)).current;

  const startAnimation = useCallback(() => {
    const timingConfig = {
      toValue: 1,
      duration: 750,
      useNativeDriver: Platform.OS !== 'web',
    };

    Animated.stagger(150, [
      Animated.timing(animationValue1, timingConfig),
      Animated.timing(animationValue2, timingConfig),
      Animated.timing(animationValue3, timingConfig),
    ]).start(() => {
      animationValue1.setValue(0);
      animationValue2.setValue(0);
      animationValue3.setValue(0);
      startAnimation();
    });
  }, [animationValue1, animationValue2, animationValue3]);

  useEffect(() => {
    startAnimation();
  }, [startAnimation]);

  const interpolationConfig = {
    inputRange: [0, 0.3, 0.6, 1],
    outputRange: [0, -7, 0, 0],
  };

  return [
    animationValue1.interpolate(interpolationConfig),
    animationValue2.interpolate(interpolationConfig),
    animationValue3.interpolate(interpolationConfig),
  ];
};
